import { createContext } from 'react';
import { type Maybe, type Sale } from '@gql/schema';

export interface IServerStateContext {
  sale?: Maybe<Sale>;
}

export const ServerStateContext = createContext<IServerStateContext | undefined>(undefined);
